export const COMANDOS_FETCH_COMANDOSDISPONIBLES = 'COMANDOS_FETCH_COMANDOSDISPONIBLES';
export const COMANDOS_SEND_COMANDOS = 'COMANDOS_SEND_COMANDOS';
export const COMANDOS_SET_SENDCOMANDORESULT = 'COMANDOS_SET_SENDCOMANDORESULT';
export const COMANDOS_SET_COMANDOSDISPONIBLES = 'COMANDOS_SET_COMANDOSDISPONIBLES';
export const FETCH_COMANDOSBYDEVICE = 'FETCH_COMANDOSBYDEVICE';
export const FETCH_COMANDOSBYTIPOUNIDAD = 'FETCH_COMANDOSBYTIPOUNIDAD';
